import { useQuery } from "@tanstack/react-query"

import { getUserPushConfig } from "lib/api/user/getUserPushConfig"

const useGetUserPushConfigQuery = (userNo, options) => {
  return useQuery(createKey(userNo), getUserPushConfig, {
    ...options,
  })
}

const createKey = (userNo) => ["user-push-config", userNo]
export default useGetUserPushConfigQuery
